import { createUseQuery } from 'api/common/createUseQuery'
import { fetchProjectDetailed } from 'api/fetchers/fetchProjectDetailed'
import { ApiQueryKeys } from 'constants/apiQueryKeys'
import { ProjectDetailed } from 'types/Project'

export const useProjectDetailed = createUseQuery({
  queryKey: ApiQueryKeys.PROJECT_DETAILED,
  fetcher: fetchProjectDetailed,
  selector: res => (res?.data as ProjectDetailed[] | undefined) ?? ({} as ProjectDetailed[]),
})
